import { useEffect } from "react";
import Navbar from "../sections/Navbar";
import Hero from "../sections/Hero";
import Services from "../sections/Services";
import Pricing from "../sections/Pricing";
import Process from "../sections/Process";
import Gallery from "../sections/Gallery";
import Reviews from "../sections/Reviews";
import StatusTracker from "../sections/StatusTracker";
import BookingForm from "../sections/BookingForm";
import Contact from "../sections/Contact";
import Footer from "../sections/Footer";
import { useSeo, LOCAL_BUSINESS_JSONLD } from "../lib/seo";

export default function HomePage() {
  useSeo({
    title: "Tombs Electronic Repair LLC · Console & PC Repair · Susquehanna, PA",
    description:
      "Honest console, PC, and laptop repair in Susquehanna PA. PS5 / Xbox / Switch cleanings, controllers, drive swaps, SSD upgrades. Drop-off or mail-in. Serving NEPA & Binghamton NY area.",
    canonical: typeof window !== "undefined" ? window.location.origin + "/" : undefined,
    jsonLd: LOCAL_BUSINESS_JSONLD,
  });

  // Land users directly on the Services section unless they arrived with their
  // own hash target (e.g. /#booking, /#track) or are scrolling back up.
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.location.hash) return;
    const el = document.getElementById("services");
    if (!el) return;
    // Defer one frame so layout settles, then jump (no smooth scroll = feels like a real landing).
    const id = window.requestAnimationFrame(() => {
      el.scrollIntoView({ block: "start", behavior: "auto" });
    });
    return () => window.cancelAnimationFrame(id);
  }, []);

  return (
    <div className="bg-[#0A0A0A] text-white" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <Pricing />
        <Process />
        <Gallery />
        <Reviews />
        <StatusTracker />
        <BookingForm />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
